import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      maxWidth: 1280,
      width: '100%',
      margin: '0 auto',
      padding: theme.spacing(4),
      backgroundColor: theme.palette.background.default,
    },
    title: {
      marginBottom: theme.spacing(2),
    },
  })
);
